import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IResendSocialPostV1Response } from './resend-social-post-v1-response';
import { resendSocialPostV1ResponseSchema } from './resend-social-post-v1-response';

export async function resendSocialPostV1Api(
  postId: number,
): Promise<IValidatedResponse<IResendSocialPostV1Response>> {
  return postRequest<IResendSocialPostV1Response>({
    path: `/sys/social/v1/posts/${postId}/resend`,
    body: {},
    schema: resendSocialPostV1ResponseSchema,
  });
}
